import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export function initSentry() {
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    tracesSampleRate: import.meta.env.PROD ? 0.15 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
  });
}

export function setSentryUser(user: { id: string; role: string; email?: string }) {
  if (!dsn) return;
  Sentry.setUser({ id: user.id, username: user.email, role: user.role } as Sentry.User & { role: string });
}

export function clearSentryUser() {
  if (!dsn) return;
  Sentry.setUser(null);
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;

export { Sentry };
